import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { NgxSpinnerService } from "ngx-spinner";
import { PaymentService } from 'src/app/services/payment.service';

@Component({
  selector: 'app-offline-booking',
  templateUrl: './offline-booking.component.html',
  styleUrls: ['./offline-booking.component.scss']
})
export class OfflineBookingComponent implements OnInit {
  token: any;
  bookingDetails: any;
  @ViewChild('paymentConfirmation') paymentConfirmation!: TemplateRef<any>;
  @ViewChild('formDialog') formDialog!: TemplateRef<any>;
  @ViewChild('errorDialog') errorDialog!: TemplateRef<any>;
  constructor(private spinner: NgxSpinnerService, private route: ActivatedRoute, private apiService: ApiService, private storage: StorageService, public dialog: MatDialog, private router: Router, private paymentService: PaymentService) {

  }

  async loadToken() {
    this.spinner.show();
    await this.apiService.offlineBookingVerify(this.token).then(
      async (response: any) => {
        if (response['success']) {
          this.storage.set('token', response["token"]);
          if (response['details'].accept_payment) {
            this.bookingDetails = {
              "booking_id": response['details'].booking_id,
              "amount": response['details'].amount,
              "order_id": response['details'].order_id,
              "payment_method": "1",
              "total_count": response['details'].order_details.total_applicants,
              "form_id": response['details'].order_details.form_details[0].id,
              "email": response['details'].booking_details.email,
              "name": response['details'].booking_details.name,
              "phone": response['details'].booking_details.phone,
              "no_of_adults": response['details'].booking_details.no_adults,
              "no_of_childs": response['details'].booking_details.no_childs
              ,
            };
            this.storage.set('booking_details', JSON.stringify(this.bookingDetails));
            this.getForm(response['details'].order_details.form_details[0].id);
            await this.showPaymentDialog();
          } else {
            this.bookingDetails = {
              "booking_id": response['details'].booking_id,
              "amount": response['details'].amount,
              "order_id": response['details'].order_id,
              "payment_method": "1",
              "total_count": response['details'].order_details.total_applicants,
              "form_id": response['details'].order_details.form_details[0].id,
              "no_of_adults": response['details'].booking_details.no_adults,
              "no_of_childs": response['details'].booking_details.no_childs
            };
            this.storage.set('booking_details', JSON.stringify(this.bookingDetails));

            this.getForm(response['details'].order_details.form_details[0].id);
            this.showFormDialog();
          }
        } else {
          this.showErrorDialog();
        }

      },
      (error) => {
        this.showErrorDialog();
      }
    );
  }

  async getForm(id: string) {
    await this.apiService.getFormById(id).then((data: any) => {
      if (data["success"]) {
        this.storage.set('form_data', JSON.stringify(data));
      }
    });
  }

  showPaymentDialog() {
    this.spinner.hide();
    let dialogRef = this.dialog.open(this.paymentConfirmation, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result === 'yes') {
          this.goToPayment();
        } else if (result === 'no') {
        }
      }
    });
  }


  showFormDialog() {
    this.spinner.hide();
    let dialogRef = this.dialog.open(this.formDialog, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result === 'yes') {
          this.router.navigate(['/form']);
        } else if (result === 'no') {
        }
      }
    });
  }

  showErrorDialog() {
    this.spinner.hide();
    let dialogRef = this.dialog.open(this.errorDialog, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result === 'yes') {
          this.router.navigate([''], { replaceUrl: true });
        } else if (result === 'no') {
        }
      }
    });
  }

  async goToPayment() {
    this.paymentService.pay(this.bookingDetails);
  }

  ngOnInit(): void {
    this.storage.clear();
    this.route.params.subscribe(params => {
      this.token = params['token'];
      this.loadToken();
    });
  }
}
